import React from 'react';
import styled from 'styled-components';
import { useTextViewStore } from '../../shared/store/TextViewStore';

const TextFontSizeToggle: React.FC = () => {
  const isLargeBody = useTextViewStore((s) => s.isLargeBody);
  const toggleIsLargeBody = useTextViewStore((s) => s.toggleIsLargeBody);

  return (
    <ToggleButton
      type="button"
      onClick={toggleIsLargeBody}
      aria-pressed={isLargeBody}
      aria-label={isLargeBody ? 'Default text size' : 'Larger text size'}
    >
      {isLargeBody ? '<  >' : '<>'}
    </ToggleButton>
  );
};

const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  padding: 0 2px;
  border: none;
  background: transparent;
  white-space: nowrap;
  ${({ theme }) => theme.typography.Footer_01};
  color: ${({ theme }) => theme.colors.color_Gray_05};
  cursor: pointer;
`;

export default TextFontSizeToggle;
